export default __webpack_public_path__ + "static/media/canada_flag.259890dc.svg";